<template>
  <ul class="footnotes">
    <li
      v-for="{ id, text } in footnotes"
      :id="getTicketFootnoteId(ticketTypeId, id)"
      :key="id"
      class="footnote wysiwyg"
      v-html="
        ariaHideAsterisks(
          // Prevent keyboard focus on links when collapsed
          nbsp(text).replace(
            /<a\b/gi,
            '<a tabindex=' + (isCollapseActive ? 0 : -1)
          )
        )
      "
    />
  </ul>
</template>

<script setup lang="ts">
import { PublicFootnotes } from '@/service/__generated-api'

const isCollapseActive = useRequiredInject<boolean>('collapse-active')

defineProps<{ ticketTypeId: number; footnotes: PublicFootnotes[] }>()
</script>

<script lang="ts">
export const getTicketFootnoteId = (ticketTypeId: number, id: number) =>
  `ticket-${ticketTypeId}-footnote-${id}`
</script>

<style scoped lang="scss">
.footnotes {
  display: grid;
  gap: rem(24px);

  @include media-up(md) {
    gap: rem(20px);
    padding-inline: rem(32px);
  }

  @include media-up(xl) {
    grid-template-columns: repeat(2, 1fr);
    gap: rem(21px) rem(45px);
    padding-inline: rem(24px) rem(45px);
  }
}
</style>
